import { Close, Search } from "@mui/icons-material"
import { InputAdornment, FormControl, InputLabel, OutlinedInput, Avatar, Button, FormHelperText } from "@mui/material"
import styled from "styled-components"
import { TStepsKeys, TStepsProps } from "../../Models/common"
import { useNavigate } from "react-router-dom"
import { ICustomerSummary } from "../../Models/Customer"
import Title from "../custom/Title"
import { useContext, useEffect, useState } from "react"
import { CustomerContext } from "../../contexts/CustomerContext"
import CustomerDetails from "./CustomerDetails"
import { searchCustomers as searchCustomerService } from "../../services/Customer"
import useService from "../../hooks/useService"
import ConfirmPhoneModal from "../Modals/ConfirmPhoneModal"
import { TransactionContext } from "../../contexts/TransactionContext"
import Modal from "../Modals"
import DynamicForm, { useDynamicForm } from "../forms/DynamicFormNew"
import { PATHS, RGPStockModal, TRANSACTION_TYPES } from "../../utils/constant"


const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 10px;
`

export const SearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: flex-start;
`

const ListContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    margin-top: 20px;
`
const ListItem = styled.div`
    display: flex;
    padding: 10px;
    background: #f1f1f1;
    border-radius: 4px;
    width: calc(33.33% - 10px);
    min-width: 200px;
    gap: 10px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover{
        background: var(--primary_color_light);
    }
`

const ItemProps = styled.div`
    display: flex;
    flex-direction: column;
`

const ItemName = styled.span`
    font-size: 14px;
    font-weight: 600;
`

const ItemMobile = styled.span`
    font-size: 12px;
`

const DividerContainer = styled.div`
    display: flex;
    gap:10px;
    align-items: center;
    margin-top: 20px;
`

const Divider = styled.div`
    height: 1px;
    border-bottom: 1px solid silver;
    width: 100%;
`

type TModalProps = {
    nextSection?: TStepsKeys;
    prevSection?: TStepsKeys;
    nextButtonLable?: string;
    path?: string;
    onClose?: () => void;
    type?: string;
}

const SelectCustomer = (props: TModalProps) => {

    const { path, nextSection, onClose, type } = props
    const navigate = useNavigate()
    const [selectedCustomerRefNo, setSelectedCustomerRefNo] = useState<boolean | string>(false)
    const [ShowMobilePopup, setShowMobilePopup] = useState(false)
    const [phone, setPhone] = useState('')

    const goToNextSection = (id:string) => {
        if(type === RGPStockModal) return
        navigate(`${path}/${id}?section=${nextSection}`)
        if(path === PATHS.MINTED_SALES)
        onClose!()
    }   

    const handleMobileConfirm = () => {
        setShowMobilePopup(false)
        setSelectedCustomerRefNo(true)
    }

    return <>
        {Boolean(selectedCustomerRefNo) ?
            <CustomerDetails
                goNext={goToNextSection}
                closeCustomerDetails={() => {setSelectedCustomerRefNo(false); onClose?.()}}
                customerRefNo={typeof selectedCustomerRefNo === 'string' ? selectedCustomerRefNo : ''}
                type={type}
                path={path}
            /> :
            <SearchCustomer
                openCustomerForm={(value) => setSelectedCustomerRefNo(value)}
                openMobilePopup={() => setShowMobilePopup(true)}
                openConfirmPhoneModal={(phone: string) => {setPhone(phone);setShowMobilePopup(true)}}
                type={type}
            />}
        <ConfirmPhoneModal
            open={ShowMobilePopup}
            onClose={() => {setShowMobilePopup(false);setPhone('')}}
            onConfirm={handleMobileConfirm}
            phoneNumber={phone}
            floatRight={path === PATHS.MINTED_SALES}
        />
    </>


}


export function SearchCustomer(props: { openCustomerForm: (value: string) => any, openMobilePopup: () => any, openConfirmPhoneModal: (phone: string) => any, type?: string }) {
    const { openCustomerForm, openMobilePopup, openConfirmPhoneModal, type } = props
    const { customers, resetCustomer, setCustomers } = useContext(CustomerContext)
    const { transactionInfo } = useContext(TransactionContext)
    const { execute } = useService()
    const [showChildModal, setShowChildModal] = useState('')

    const [searchString, setSearchString] = useState('')

    const searchCustomer = () => {
        console.log('transactionInfo', transactionInfo)
        console.log('transactionInfo', [TRANSACTION_TYPES.BUY_SELL, TRANSACTION_TYPES.JOB_WORK].includes(transactionInfo.transactionType))
        if (searchString.length === 0) return setCustomers([])
        if (searchString.length === 1) return
        execute(() => searchCustomerService({ searchString, b2BOnly: [TRANSACTION_TYPES.BUY_SELL, TRANSACTION_TYPES.JOB_WORK].includes(transactionInfo.transactionType) }))
            .then(response => {
                if(response.data && response.data.length === 0 && !isNaN(parseInt(searchString)) && searchString.length === 10 && ![ TRANSACTION_TYPES.JOB_WORK, TRANSACTION_TYPES.BUY_SELL ].includes(transactionInfo.transactionType)) openConfirmPhoneModal(searchString)
            })
    }

    // useEffect(() => {
    //     const timer = setTimeout(() => searchCustomer(), 500)
    //     return () => clearTimeout(timer)
    // }, [searchString])

    const handleKeyDown = (event : any) => {
        if (event.key === 'Enter') {
          event.preventDefault(); // Prevent the default action (form submission or other)
          searchCustomer(); // Call your function when Enter is pressed
        }
      };

    useEffect(() => {
        resetCustomer()
    }, [])

    return <>
        <Container>
            <SearchContainer>
                <div style={{ width: '100%' }}>
                    <FormControl variant="outlined" fullWidth >
                        <InputLabel htmlFor="search_customer">Search Customer</InputLabel>
                        <OutlinedInput
                            id="search_customer"
                            placeholder="By Name, Mobile, GSTIN, PAN"
                            label='Search Customer'
                            endAdornment={
                                <InputAdornment position='end'>
                                    <Search />
                                    <Button onClick={searchCustomer}>Search</Button>
                                </InputAdornment>
                            }
                            onChange={(e) => setSearchString(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        {searchString.length < 2 && <FormHelperText >To Search Customer Enter Atleast 2 Characters</FormHelperText>}
                    </FormControl>
                </div>
                {(transactionInfo.transactionType === TRANSACTION_TYPES.BUY_SELL || transactionInfo.transactionType === TRANSACTION_TYPES.JOB_WORK) ? <></> : type !== RGPStockModal && <Button variant="outlined" style={{ whiteSpace: 'nowrap', width: '250px', height: '56px' }} onClick={openMobilePopup}>New Customer</Button>}
            </SearchContainer>
            <DividerContainer>
                <Divider />
                <Title style={{ whiteSpace: 'nowrap' }}>Search Results</Title>
                <Divider />
            </DividerContainer>
            <ListContainer>
                {customers.map(customer => {
                    return <ListItem key={customer.customerRefNo} onClick={() => {
                        if (customer.children && customer.children.length) setShowChildModal(customer.customerRefNo)
                        else openCustomerForm(customer.customerRefNo)
                    }}>
                        <div>
                            {
                                customer.imageUrl ?
                                    <Avatar src={customer.imageUrl} /> :
                                    <Avatar>
                                        {customer.fullName?.split(' ')?.map(str => str.substring(0, 1)).join('').substring(0, 2)?.toUpperCase()}
                                    </Avatar>
                            }
                        </div>
                        <ItemProps>
                            <ItemName>{customer.fullName}</ItemName>
                            <ItemMobile>{customer.mobileNumber}</ItemMobile>
                        </ItemProps>
                    </ListItem>
                })}
            </ListContainer>
        </Container>
        <ChildCustomerModal
            open={Boolean(showChildModal)}
            customer={customers.filter(customer => customer.customerRefNo === showChildModal)[0]}
            onSelect={openCustomerForm}
            onClose={() => setShowChildModal('')}
        />
    </>
}

const ChildCustomerModal = (props: { open: boolean, customer: ICustomerSummary, onSelect: (value: string) => any, onClose: () => any }) => {
    const { customer, onClose, onSelect, open } = props
    const { registerForm, setFormConfig } = useDynamicForm({
        formConfig: [
            {
                fieldName: 'childCustomer',
                isVisible: true,
                fieldType: 'select',
                label: 'Location',
                options: []
            }
        ]
    })

    useEffect(() => {
        setFormConfig([
            {
                fieldName: 'childCustomer',
                isVisible: true,
                fieldType: 'select',
                label: 'Location',
                fullWidth: true,
                options: customer?.children?.map(child => ({ label: child.fullName, value: child.customerRefNo }))
            }
        ])
    }, [customer])
    return <Modal open={open} onClose={onClose} title="Select Location">
        <div style={{ width: '300px' }}>
            <DynamicForm {...registerForm()} onSubmit={(data) => onSelect(data.childCustomer)} submitText="Continue" />
        </div>
    </Modal>
}

export default SelectCustomer